'use client';

import { useCallback } from 'react';
import { throttle } from '@bts-web/utils-functions';
import { ButtonBase } from '../ButtonBase/ButtonBase';
import { useAppNotification } from '../../../notifications/NotificationContextProvider';
import { RegularCopy } from '../../../common/svgIcons';

interface CopyToClipboardProps {
  value: string;
  translations: {
    copy?: string;
    successMessage: string;
    failedMessage: string;
  };
}

export const CopyToClipboard = ({
  translations,
  value,
}: CopyToClipboardProps) => {
  const { copy, successMessage, failedMessage } = translations;

  const { setAppNotification } = useAppNotification();

  const copyToClipboardAndShowNotification = async () => {
    try {
      await navigator.clipboard.writeText(value);

      setAppNotification({
        title: successMessage,
        visual: 'success',
        customDuration: 3000,
      });
    } catch (_error) {
      setAppNotification({
        title: failedMessage,
        visual: 'error',
        customDuration: 3000,
      });
    }
  };

  const handleCopyToClipboard = useCallback(
    throttle(() => copyToClipboardAndShowNotification(), 4000),
    [value],
  );

  return (
    <ButtonBase
      data-testid={`copy-clipboard-${value}`}
      onClick={() => handleCopyToClipboard()}
      visual="ghost"
      size="small"
      noPadding
      withBorderRadius={false}
    >
      {copy}
      <RegularCopy />
    </ButtonBase>
  );
};
